/**
 * Что делать с записью, когда часы стёрли в ноль.
 *
 * Ноль — это ЗНАЧЕНИЕ, а не «ничего». У записи с заметкой или attendance-кодом
 * (в том числе Night work) сама запись обязана остаться — день отсутствия и
 * ночная смена валидны с 0 часов, а код нужен payroll. Но и часы обязаны
 * обнулиться.
 *
 * Ради этого правило и вынесено из компонента: в клавиатуре грида его не было
 * вовсе — условие удаления отсекало записи с кодом, а ветки на обновление никто
 * не написал. У сотрудника с ночным кодом часы просто не стирались, сколько ни
 * вводи 0, и увидеть это можно было только руками на айпаде.
 *
 * Пустую запись (без заметки и кода) удаляем: 0ч-пустышка уедет в синк и осядет
 * в payroll мусорной строкой.
 *
 * @param {{notes?: string, attendCode?: string}} record
 * @returns {'update'|'remove'} update — оставить запись с 0 часов; remove — удалить
 */
export function zeroingPlan(record) {
    return (record?.notes || record?.attendCode) ? 'update' : 'remove';
}

export default zeroingPlan;
